import { theme } from '../../constants/defaults';
import cartModalTemplate from '../../templates/cartModalTemplate';
import Cart from './Cart';
import quantitySelect from '../layout/quantitySelect';
import { formatMoney } from '../../utils/product';

export default class CartModal {
  constructor() {
    if (theme.settings.ajaxCartEnabled) {
      this.cart = Cart.getInstance();
      this.cartContainer = document.getElementById('cart-container');

      const modalNamespace = 'cart-modal';
      this.modal = window.modalManager.idModalMap.get(modalNamespace);

      this.modal.on('before-show', () => {
        this.cartContainer.innerHTML = cartModalTemplate(true);

        this.cart.getState().then(state => {
          this.buildCart(state);
        });
      });
    }
  }

  buildCart(initialState) {
    this.cartContainer.innerHTML = cartModalTemplate(false, initialState);

    // Update cart when quantity of item has changed
    const qtySelects = [...this.cartContainer.querySelectorAll('.js-quantity-select')];
    const qtySelectCallback = (input, quantity) => {
      const { key } = input.dataset;
      const itemEl = this.cartContainer.querySelector(`.ajaxcart__product[data-key="${key}"]`);

      if (quantity === 0) {
        // Remove item
        itemEl.classList.add('is-removing');
        this.cart.removeItem(key).then(() => {
          itemEl.remove();
        });
      } else {
        // Update item
        itemEl.classList.add('is-updating');
        this.cart.updateItem(key, { quantity }).then(() => {
          itemEl.classList.remove('is-updating');
        });
      }
    };

    // Update note
    const note = this.cartContainer.querySelector('textarea[name="note"]');
    if (note) {
      note.addEventListener('change', () => {
        this.cart.updateNote(note.value);
      });
    }

    // If the quantity specified is more then what is available,
    // the promise will still be fullfilled and
    // the maximum number of available items is added to the cart.
    // So we need to update the input field with the quantity in the cart
    this.cart.on('updated', (item, state) => {
      // Update product quantity & price
      if (item) {
        const { key, quantity, line_price: linePrice } = item;
        const product = this.cartContainer.querySelector(`.ajaxcart__product[data-key="${key}"]`);

        if (product) {
          const inputEl = product.querySelector('input[name="updates[]"]');
          const priceEl = product.querySelector('.ajaxcart__price');

          if (inputEl) {
            inputEl.value = quantity;
          }

          if (priceEl) {
            priceEl.innerHTML = formatMoney(linePrice);
          }
        }
      }

      // Update subtotal
      const { total_price: totalPrice } = state;
      const totalPriceFormatted = formatMoney(totalPrice);
      this.cartContainer.querySelector('.ajaxcart__total-price').innerHTML = totalPriceFormatted;
    });

    quantitySelect(qtySelects, qtySelectCallback);

    this.cartContainer.querySelectorAll('.js-modal-close').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        this.modal.hide();
      });
    });
  }
}
